
import Ankr from "../../../assets/filled/Ankr.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AnkrIcon({ className, dataTestid = "AnkrIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Ankr data-testid={dataTestid} className={classes} {...rest} />
  );
}
